// removed by extract-text-webpack-plugin
module.exports = {"header":"style__header___3rTxv","headerBackBtn":"style__headerBackBtn___dLoZd","headerText":"style__headerText___3h3lr"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/components/header/style.css
// module id = 836
// module chunks = 0